import type { PerformanceMode } from "../types/astronomy";

export function getOrbitSampleCount(
  bodyType: string,
  mode: PerformanceMode,
): number {
  const base =
    bodyType === "planet" ? 256 : bodyType === "moon" ? 128 : 64;

  if (mode === "performance") return Math.max(64, Math.floor(base / 2));
  if (mode === "quality") return base;
  return Math.floor(base * 0.75);
}

export function shouldEnableShadows(mode: PerformanceMode): boolean {
  return mode === "quality";
}
